import React, { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";

import { convertTimeStampLocalDateTime } from "../../../utilities/commonFunctions/timeConversionFunctions";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";

const FileUploadTable = ({ data }) => {
  const history = useHistory();
  const [item, setItem] = useState(null);
  const handleRowClick = (row) => {
    setItem(row.row.original);
  };

  useEffect(() => {
    if (item) {
      history.push({ pathname: "/ddw-admin/file-upload/file-upload-review", state: { item } });
    }
  }, [item, history]);

  let columns = [
    {
      Header: "System Name",
      accessor: (d) => {
        return `${d.pwsNumber} ${d.systemName}`;
      },
      width: 200
    },
    {
      Header: "File Type",
      accessor: "fileTypeDescription",
      width: 100
    },
    {
      Header: "Status",
      accessor: "fileStatus",
      width: 80
    },
    {
      Header: "Uploaded On / By",
      accessor: (d) => {
        return d.createdOn ? convertTimeStampLocalDateTime(d.createdOn) + " " + d.createdBy : "";
      },
      width: 100
    },
    {
      Header: "",
      id: "review",
      Cell: (row) => {
        return (
          <>
            <div className='text-center' style={{ color: "#157995" }}>
              <span style={{ cursor: "pointer" }} onClick={() => handleRowClick(row)}>
                Review
              </span>
            </div>
          </>
        );
      },
      width: 75,
      disableFilters: true
    }
  ];
  return data.length > 0 ? (
    <DtsReactTable
      columns={columns}
      data={data}
      headerColor='ddw'
      showGlobalFilter
      showPagination={data.length > 10}
      rowOnClick={true}
      rowClickHandler={handleRowClick}
      cypressid='file-upload-review-tbl'
    />
  ) : (
    <span>There are no documents pending review.</span>
  );
};
export default withRouter(FileUploadTable);
